export function getLinkTargetAttrs(linkUrl, openInNewTab) {
  const lowerHref = (linkUrl || '').toLowerCase();
  const isQuiz = lowerHref.includes('quiz');

  let target;
  if (isQuiz) {
    target = '_self';
  } else if (openInNewTab) {
    target = '_blank';
  }

  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

  return { target, rel };
}
